// extracted by mini-css-extract-plugin
export default {"image":"RW-z","loaded":"SW-z"};